import React from 'react'
import { reducer } from './utils'

import * as El from '../styles'

export default ({ field, form: { touched, errors }, ...props }) => {
  const element = reducer(props.form_s, field.name)
  const error = reducer(errors, field.name)
  const touch = reducer(touched, field.name)
  const price = element.prices
  return (
    <div>
      {element.title && (
        <El.Title error={(error && touch) || null}>{element.title}</El.Title>
      )}
      <El.Group>
        {element.values.map((e, i) => (
          <El.Label key={i}>
            <span className='label'>{e}</span>
            <div>{price && price[i] && price[i]}</div>
            <El.Radio
              type='radio'
              value={e}
              name={field.name}
              onChange={props.onChange || field.onChange}
              onBlur={field.onBlur}
              defaultChecked={props.default === i}
            />
            <El.Checkmark />
          </El.Label>
        ))}
        {error && touch && <El.Error>{error}</El.Error>}
      </El.Group>
    </div>
  )
}
